import { useState } from 'react'

import { Form as FormContainer } from 'components/Form'
import { CommonProps } from '../types'
import { Form } from './Form'
import { useConnectBannerAndOutstreamToGam } from './hooks/useConnectBannerAndOutstreamToGam'
import { schema, Schema, schemaDefault } from './schema'

export const BannerAndOutstreamForm = ({
  gamSetupOrder,
  getFreshStatusAndError,
}: Pick<CommonProps, 'gamSetupOrder' | 'getFreshStatusAndError'>): React.JSX.Element => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
  const {
    connect,
    errors: apiErrors,
    loading,
  } = useConnectBannerAndOutstreamToGam({ setIsDialogOpen })

  const formId = 'gam-connection-banner-and-outstream'

  return (
    <FormContainer<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={connect}
      schema={schema}
      schemaDefaults={schemaDefault(gamSetupOrder)}
    >
      {() => (
        <Form
          formId={formId}
          gamSetupOrder={gamSetupOrder}
          getFreshStatusAndError={getFreshStatusAndError}
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
        />
      )}
    </FormContainer>
  )
}
